import useVehicleHistory, { mergeVehicleFields, vehicleCustomer, vehicleDetails } from "./useVehicleHistory";
import ServiceOrderFields from "./ServiceOrderFields";
import ServiceAnnexes from "./ServiceAnnexes";
import HeaderCostCenter from "../nc/HeaderCostCenter";
// src/components/comenzi/InternList.jsx
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Alert,
  Spinner,
  Badge,
  Form,
  InputGroup,
  Card,
  Modal,
  Tabs,
  Tab,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import { authFetch } from "../utils/authFetch";
import PartPickerModal from "../pickers/PartPickerModal";
import StocCurentPickerModal from "../pickers/StocCurentPickerModal";
import ManoperaPickerModal from "../pickers/ManoperaPickerModal";
import { applyLaborNorm, updateLaborAmount } from "./manoperaCalculation";
import api from "../../axiosConfig";
import RecipePriceCells from "./RecipePriceCells";
import { saleFromMarkup, lookupRecipeSalePrice } from "./recipePricing";
import LaborEmployees, { LaborEmployeeSummary } from "./LaborEmployees";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function formatDateRo(val) {
  if (!val) return "";
  const s = String(val);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  return s;
}

function formatDateTimeLocal(val) {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export default function InternalOrdersList() {
  const navigate = useNavigate();
  const invoiceOpened = useRef(false);
  const openDevizInvoice = (draft) => {
    if (invoiceOpened.current) return;
    invoiceOpened.current = true;
    navigate("/iesire/new?from_deviz=1", { state: { devizInvoice: draft } });
  };
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [ums, setUms] = useState([]);
  const [gestiuni, setGestiuni] = useState([]);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferState, setTransferState] = useState({ sursa: 1, dest: 2 });
  const [isTransferring, setIsTransferring] = useState(false);
  
  const [showInchidereModal, setShowInchidereModal] = useState(false);
  const [inchidereGestiune, setInchidereGestiune] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Filters
  const [search, setSearch] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  // Modal for internal order details & editing
  const [selectedInternalOrder, setSelectedInternalOrder] = useState(null);
  const [formOrder, setFormOrder] = useState(null);
  const [savingInternalOrder, setSavingInternalOrder] = useState(false);
  const [isScading, setIsScading] = useState(false);
  const [modalTab, setModalTab] = useState("general");
  const [partPickerOpen, setPartPickerOpen] = useState(false);
  const [stocPickerOpen, setStocPickerOpen] = useState(false);
  const [activeRecipeLineIdx, setActiveRecipeLineIdx] = useState(null);
  const [loadingInternalOrder, setLoadingInternalOrder] = useState(false);
  const [showInternalOrderModal, setShowInternalOrderModal] = useState(false);
  const [appVariant, setAppVariant] = useState("STANDARD");
  const [pickingMainPart, setPickingMainPart] = useState(false);
  const [tarifSkill1, setTarifSkill1] = useState(0.0);
  const [tarifSkill2, setTarifSkill2] = useState(0.0);
  const [manoperaPickerOpen, setManoperaPickerOpen] = useState(false);
  const [activeManoperaLineIdx, setActiveManoperaLineIdx] = useState(null);

  const vinMessage = useVehicleHistory(formOrder?.bxsasiu,
    appVariant === "SERVICE_AUTO" && showInternalOrderModal && !loadingInternalOrder && !!formOrder && !formOrder.bxid,
    (data, previous) => {
      setFormOrder(current => current ? {
        ...mergeVehicleFields(current,
          data ? { ...vehicleCustomer(data), bxnumar: data.bxnumar || '' } : {},
          previous ? { ...vehicleCustomer(previous), bxnumar: previous.bxnumar || '' } : {}),
        service_details: mergeVehicleFields(current.service_details || {}, vehicleDetails(data), vehicleDetails(previous)),
      } : current);
    });

  // Load appVariant and tariffs
  useEffect(() => {
    async function loadFirma() {
      try {
        const res = await authFetch("/firma");
        if (res && res.items && res.items.length > 0) {
          setAppVariant(res.items[0].app_variant || "STANDARD");
          setTarifSkill1(res.items[0].tarif_skill1 || 0.0);
          setTarifSkill2(res.items[0].tarif_skill2 || 0.0);
        }
      } catch (err) {
        console.error(
          "Eroare la încărcarea variantei aplicației și tarifelor:",
          err,
        );
      }
    }
    loadFirma();
  }, []);

  const contactBases = ["/contacte/"];

  const fetchFirstOk = async (urls) => {
    for (const u of urls) {
      try {
        const r = await authFetch(u);
        if (r && typeof r === "object" && !("ok" in r) && !("status" in r)) {
          return { __json: r };
        }
        if (r && typeof r === "object" && "ok" in r) {
          if (r.ok) return r;
        }
      } catch (e) {
        // silent
      }
    }
    return null;
  };

  const loadContacts = async (inputValue) => {
    try {
      const q = (inputValue || "").trim();
      const url = (base) =>
        `${base}?skip=0&limit=20&q=${encodeURIComponent(q)}`;

      const r = await fetchFirstOk(contactBases.map(url));
      if (!r) return [];

      const data = r.__json ? r.__json : await r.json();
      const items = data.items || data.results || data || [];

      return items.map((c) => ({
        value: c.id,
        label: c.bxdenumire,
      }));
    } catch (e) {
      console.error("loadContacts failed", e);
      return [];
    }
  };

  // Load UMs nomenclature
  useEffect(() => {
    async function loadInitialData() {
      try {
        const u = await authFetch("/bxums?limit=500");
        setUms(u?.items || (Array.isArray(u) ? u : []));
      } catch (err) {
        console.error("Eroare la incarcare UM:", err);
      }
      try {
        const g = await authFetch("/bxgestiune");
        setGestiuni(g?.items || (Array.isArray(g) ? g : []));
      } catch (err) {
        console.error("Eroare la incarcare Gestiuni:", err);
      }
    }
    loadInitialData();
  }, []);

  // Fetch orders list
  const fetchList = async () => {
    setLoading(true);
    setError("");
    try {
      const skip = currentPage * itemsPerPage;
      const usp = new URLSearchParams();
      if (search.trim()) usp.set("search", search.trim());
      usp.set("skip", String(skip));
      usp.set("limit", String(itemsPerPage));

      const path = `/comenzi/interna/linii?${usp.toString()}`;
      const data = await authFetch(path);

      if (data && Array.isArray(data.items)) {
        setItems(data.items);
        setTotalCount(data.total);
      } else {
        setItems([]);
        setTotalCount(0);
      }
    } catch (e) {
      setError(e.message || "Eroare la preluarea comenzilor interne.");
    } finally {
      setLoading(false);
    }
  };

  // Trigger fetch on page/limit change
  useEffect(() => {
    const t = setTimeout(fetchList, 250);
    return () => clearTimeout(t);
  }, [currentPage, itemsPerPage]);

  // Restabiliți scrollbar-ul pe body când se închid picker-ele imbricate
  useEffect(() => {
    if (showInternalOrderModal) {
      const checkAndRestore = () => {
        if (
          showInternalOrderModal &&
          !document.body.classList.contains("modal-open")
        ) {
          document.body.classList.add("modal-open");
        }
      };
      const t = setTimeout(checkAndRestore, 300);
      const interval = setInterval(checkAndRestore, 1000);
      return () => {
        clearTimeout(t);
        clearInterval(interval);
      };
    }
  }, [
    showInternalOrderModal,
    partPickerOpen,
    stocPickerOpen,
    manoperaPickerOpen,
  ]);

  // Handle Search submit
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(0);
    fetchList();
  };

  // Handle Clear filters
  const handleClearFilters = () => {
    setSearch("");
    setCurrentPage(0);
  };

  // View internal order details in modal
  const handleViewInternalOrder = async (internalOrderId) => {
    setLoadingInternalOrder(true);
    setShowInternalOrderModal(true);
    setModalTab("general");
    try {
      const data = await authFetch(`/comenzi/interna/${internalOrderId}`);
      setSelectedInternalOrder(data);
      setFormOrder(data);
    } catch (err) {
      toast.error(
        err.message || "Eroare la încărcarea detaliilor de comandă internă.",
      );
      setShowInternalOrderModal(false);
    } finally {
      setLoadingInternalOrder(false);
    }
  };

  useEffect(() => {
    const openId = new URLSearchParams(window.location.search).get('open');
    if (openId && /^\d+$/.test(openId)) handleViewInternalOrder(Number(openId));
    // Open the estimate selected by the client-order page on entry.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrintDeviz = (id) => {
    window.open(`/comenzi/interna/${id}/print${appVariant === "SERVICE_AUTO" ? "?document=comanda" : ""}`, "_blank", "noopener");
  };

  const handleAddInternalOrder = () => {
    setFormOrder({
      bxid: null,
      bxnumar_comanda: "",
      bxdescr: "",
      bxcustomer_id: null,
      customer_name: "",
      bxdata_comanda: new Date().toISOString(),
      bxlvalue: 0.0,
      bxunitate_id: 1,
      tipcomanda_id: 2,
      bxsasiu: "",
      bxnumar: "",
      bxkm: "",
      bxdovada: "",
      bxpart_id: null,
      part_code: "",
      part_name: "",
      bxcantitate: 1.0,
      bxprice: 0.0,
      bxcant_ramas: 1.0,
      manopere: [],
      reteta: [],
    });
    setSelectedInternalOrder(null);
    setModalTab("general");
    setShowInternalOrderModal(true);
  };

  // Header field change
  const handleHeaderChange = (field, val) => {
    setFormOrder((prev) => {
      const updated = { ...prev, [field]: val };
      if (field === "bxcantitate" || field === "bxprice") {
        const cant = Number(updated.bxcantitate) || 0;
        const price = Number(updated.bxprice) || 0;
        updated.bxlvalue = cant * price;
      }
      return updated;
    });
  };

  // Labor row handlers
  const handleAddManopera = () => {
    const newRow = {
      bxdata_manopera: new Date().toISOString(),
      bxqty_manopera: 1.0,
      bxqty_manopera1: 0.0,
      bxpret_manopera: 0.0,
      bxtotal_manopera: 0.0,
      bxspecificatii: "",
      bxcentrucost_id: formOrder?.centrucost_id || 1,
      bxmanoperacod_id: 1,
      bxunitate_id: formOrder?.bxunitate_id || 1,
      bxtip: 1,
      bxtiptarif: 1,
      bxremiza: 0.0,
      qty_executat: 0,
    };
    setFormOrder((prev) => ({
      ...prev,
      manopere: [...(prev.manopere || []), newRow],
    }));
  };

  const handleUpdateManopera = (index, field, val) => {
    setFormOrder((prev) => {
      const list = [...(prev.manopere || [])];
      list[index] = updateLaborAmount(list[index], field, val);
      return { ...prev, manopere: list };
    });
  };

  const handleRemoveManopera = (index) => {
    setFormOrder((prev) => {
      const list = [...(prev.manopere || [])];
      list.splice(index, 1);
      return { ...prev, manopere: list };
    });
  };

  // Recipe row handlers
  const handleAddRecipeLine = (rectype = 1) => {
    const newRow = {
      bxum_id: ums[0]?.id || 1,
      bxpart_id: 0,
      part_code: "",
      part_name: "",
      bxnorma: 1.0,
      deluat: rectype === 11 ? 1.0 : 0.0,
      luat: 0.0,
      bxrectype: rectype,
      bxegal: 1,
      bxrestqty: rectype === 11 ? 1.0 : 0.0,
      pretvanzare: 0.0,
      pret_magazie: null,
      qty_proforma: 0.0,
      bxremiza: 0.0,
      inchid_fortat: 0,
      data_scadere: new Date().toISOString().split("T")[0],
    };
    setFormOrder((prev) => ({
      ...prev,
      reteta: [...(prev.reteta || []), newRow],
    }));
  };

  const handleUpdateRecipeLine = (index, field, val) => {
    setFormOrder((prev) => {
      const list = [...(prev.reteta || [])];
      const item = { ...list[index], [field]: val };
      if (field === "adaos") {
        if (!(Number(item.pret_magazie) > 0)) return prev;
        item.pretvanzare = saleFromMarkup(item.pret_magazie, val);
      }
      if (field === "adaos" || field === "pretvanzare") {
        item._priceRequest = null;
        item._priceLoading = false;
      }
      if (field === "bxnorma" || field === "luat") {
        const norma = Number(item.bxnorma) || 0;
        const luat = Number(item.luat) || 0;
        item.bxrestqty = Math.max(0, norma - luat);
      }
      list[index] = item;
      return { ...prev, reteta: list };
    });
  };

  const handleRemoveRecipeLine = (index) => {
    setFormOrder((prev) => {
      const list = [...(prev.reteta || [])];
      list.splice(index, 1);
      return { ...prev, reteta: list };
    });
  };

  const handleOpenPartPickerForRecipe = (idx) => {
    setActiveRecipeLineIdx(idx);
    setPickingMainPart(false);
    setStocPickerOpen(true);
  };

  const handleOpenPartPickerForMain = () => {
    setPickingMainPart(true);
    setActiveRecipeLineIdx(null);
    setPartPickerOpen(true);
  };

  const handlePickPart = (selectedPart) => {
    if (pickingMainPart && selectedPart) {
      setFormOrder((prev) => ({
        ...prev,
        bxpart_id: selectedPart.id,
        part_code: selectedPart.raw?.cod || "",
        part_name: selectedPart.raw?.denumire || "",
      }));
    }
    setPartPickerOpen(false);
    setPickingMainPart(false);
  };

  const handlePickPartForRecipe = async (selectedPart) => {
    const request = Symbol("recipe-price");
    const contactId = formOrder?.bxcustomer_id;
    const cost = Number(selectedPart?.raw?.pret_magazie) || 0;
    if (activeRecipeLineIdx !== null && selectedPart) {
      setFormOrder((prev) => {
        const list = [...(prev.reteta || [])];
        const row = { ...list[activeRecipeLineIdx] };
        row.bxpart_id = selectedPart.id;
        row.part_code = selectedPart.raw?.cod || "";
        row.part_name = selectedPart.raw?.denumire || "";
        if (selectedPart.raw?.um_id) {
          row.bxum_id = selectedPart.raw.um_id;
        }
        row.pret_magazie = cost;
        row.pretvanzare = cost;
        row._priceRequest = request;
        row._priceLoading = true;
        list[activeRecipeLineIdx] = row;
        return { ...prev, reteta: list };
      });
    }
    setStocPickerOpen(false);
    setActiveRecipeLineIdx(null);
    if (!selectedPart) return;
    try {
      const price = await lookupRecipeSalePrice(api, contactId, selectedPart.id, cost);
      setFormOrder((prev) => {
        if (!prev) return prev;
        return { ...prev, reteta: (prev.reteta || []).map((row) => row._priceRequest === request
          ? { ...row, pretvanzare: prev.bxcustomer_id === contactId ? price : cost, _priceLoading: false, _priceRequest: null }
          : row) };
      });
    } catch (error) {
      toast.warning(error.response?.data?.detail || (error.response ? "Catalogul nu a putut fi verificat. Verificați prețul de vânzare; s-a păstrat prețul de magazie." : error.message));
      setFormOrder((prev) => prev ? { ...prev, reteta: (prev.reteta || []).map((row) => row._priceRequest === request
        ? { ...row, _priceLoading: false, _priceRequest: null } : row) } : prev);
    }
  };

  const handlePickManopera = (selectedManopera) => {
    if (activeManoperaLineIdx !== null && selectedManopera) {
      setFormOrder((prev) => {
        const list = [...(prev.manopere || [])];
        const row = { ...list[activeManoperaLineIdx] };

        row.bxmanoperacod_id = selectedManopera.id;
        row.bxmanoperacod = selectedManopera.code;
        row.bxspecificatii = selectedManopera.name || "";

        Object.assign(
          row,
          applyLaborNorm(row, selectedManopera, tarifSkill1, tarifSkill2),
        );

        list[activeManoperaLineIdx] = row;
        return { ...prev, manopere: list };
      });
    }
    setManoperaPickerOpen(false);
    setActiveManoperaLineIdx(null);
  };

  // Save internal order modifications
  const handleSaveInternalOrder = async () => {
    if (formOrder?.reteta?.some((row) => row._priceLoading)) {
      toast.info("Așteptați verificarea prețurilor din catalog.");
      return;
    }
    if (!formOrder || !formOrder.bxcustomer_id) {
      toast.error("Vă rugăm să selectați un client.");
      return;
    }
    if (appVariant !== "SERVICE_AUTO" && !formOrder.bxpart_id) {
      toast.error("Vă rugăm să alegeți piesa/produsul fabricat.");
      return;
    }

    // Validate recipe lines
    if (formOrder.reteta && formOrder.reteta.length > 0) {
      for (let i = 0; i < formOrder.reteta.length; i++) {
        const r = formOrder.reteta[i];
        if (!r.bxpart_id || Number(r.bxpart_id) <= 0) {
          toast.error(
            `Linia ${i + 1} din Rețetă: Vă rugăm să alegeți un produs/material din stoc.`,
          );
          return;
        }
        if (Number(r.bxnorma) <= 0) {
          toast.error(
            `Linia ${i + 1} din Rețetă: Cantitatea (Norma) trebuie să fie mai mare decât 0.`,
          );
          return;
        }
      }
    }

    // Validate labor lines
    if (formOrder.manopere && formOrder.manopere.length > 0) {
      for (let i = 0; i < formOrder.manopere.length; i++) {
        const m = formOrder.manopere[i];
        if (!m.bxmanoperacod_id || Number(m.bxmanoperacod_id) <= 0) {
          toast.error(
            `Linia ${i + 1} din Manoperă: Vă rugăm să alegeți un cod de manoperă.`,
          );
          return;
        }
        if (Number(m.bxqty_manopera) <= 0) {
          toast.error(
            `Linia ${i + 1} din Manoperă: Cantitatea de manoperă trebuie să fie mai mare decât 0.`,
          );
          return;
        }
      }
    }
    setSavingInternalOrder(true);
    try {
      const payload = {
        bxnumar_comanda: formOrder.bxnumar_comanda,
        bxdescr: formOrder.bxdescr,
        service_details: formOrder.service_details || null,
        centrucost_id: formOrder.centrucost_id || null,
        bxcustomer_id: formOrder.bxcustomer_id,
        bxdata_comanda: formOrder.bxdata_comanda,
        bxlvalue: Number(formOrder.bxlvalue) || 0.0,
        bxunitate_id: formOrder.bxunitate_id,
        tipcomanda_id: formOrder.tipcomanda_id,
        bxsasiu: formOrder.bxsasiu,
        bxnumar: formOrder.bxnumar,
        bxkm: formOrder.bxkm,
        bxdovada: formOrder.bxdovada,
        bxpart_id: formOrder.bxpart_id,
        bxcantitate: Number(formOrder.bxcantitate) || 0.0,
        bxprice: Number(formOrder.bxprice) || 0.0,
        bxcant_ramas: Number(formOrder.bxcant_ramas) || 0.0,
        bxdatafin: formOrder.bxdatafin || null,

        manopere: (formOrder.manopere || []).map((m) => ({
          bxid: m.bxid,
          bxdata_manopera: m.bxdata_manopera,
          bxqty_manopera: Number(m.bxqty_manopera) || 0.0,
          bxqty_manopera1: Number(m.bxqty_manopera1) || 0.0,
          bxtotal_manopera: Number(m.bxtotal_manopera) || 0.0,
          bxpret_manopera: Number(m.bxpret_manopera) || 0.0,
          detalii_angajati: (m.detalii_angajati || []).map((d) => ({
            bxangajat_id: d.bxangajat_id,
          })),
          bxspecificatii: m.bxspecificatii || "",
          bxcentrucost_id: Number(m.bxcentrucost_id) || 1,
          bxmanoperacod_id: Number(m.bxmanoperacod_id) || 1,
          bxunitate_id: Number(m.bxunitate_id) || 1,
          bxtip: Number(m.bxtip) || 1,
          bxtiptarif: m.bxtiptarif !== undefined ? Number(m.bxtiptarif) : null,
          bxremiza: m.bxremiza !== undefined ? Number(m.bxremiza) : null,
          qty_executat:
            m.qty_executat !== undefined ? Number(m.qty_executat) : null,
        })),

        reteta: (formOrder.reteta || []).map((r) => ({
          bxid: r.bxid,
          bxum_id: Number(r.bxum_id),
          bxpart_id: Number(r.bxpart_id),
          bxnorma: Number(r.bxnorma) || 0.0,
          deluat: Number(r.deluat) || 0.0,
          luat: Number(r.luat) || 0.0,
          bxrectype: Number(r.bxrectype) || 1,
          bxegal: Number(r.bxegal) || 1,
          bxrestqty: Number(r.bxrestqty) || 0.0,
          pretvanzare: Number(r.pretvanzare) || 0.0,
          pret_magazie: r.pret_magazie == null ? null : Number(r.pret_magazie),
          qty_proforma: Number(r.qty_proforma) || 0.0,
          bxremiza: Number(r.bxremiza) || 0.0,
          bxcomtr_id: r.bxcomtr_id,
          inchid_fortat: Number(r.inchid_fortat) || 0,
          data_scadere: r.data_scadere || null,
        })),
      };

      const isCreate = !formOrder.bxid;
      const url = isCreate
        ? "/comenzi/interna"
        : `/comenzi/interna/${formOrder.bxid}`;
      const method = isCreate ? "POST" : "PUT";

      const result = await authFetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      toast.success("Comanda internă a fost salvată cu succes!");
      setSelectedInternalOrder(result);
      setFormOrder(result);
      fetchList();
    } catch (err) {
      toast.error(err.message || "Eroare la salvarea comenzii interne.");
    } finally {
      setSavingInternalOrder(false);
    }
  };

  // Stock decrement logic
  const handleScadeStoc = async () => {
    if (
      !window.confirm(
        "Sigur doriți să realizați scăderea din stoc (FIFO) pentru materialele din rețetă cu cantitatea 'De luat' > 0? Această operațiune va genera un bon de consum.",
      )
    ) {
      return;
    }
    setIsScading(true);
    try {
      const result = await authFetch(
        `/comenzi/interna/${formOrder.bxid}/scade-stoc`,
        {
          method: "POST",
        },
      );
      toast.success(
        "Scăderea din stoc a fost realizată cu succes! S-a generat un bon de consum.",
      );
      setSelectedInternalOrder(result);
      setFormOrder(result);
      fetchList();
    } catch (err) {
      toast.error(err.message || "Eroare la scăderea din stoc.");
    } finally {
      setIsScading(false);
    }
  };

  const handleTransfer = async () => {
    if (!transferState.sursa || !transferState.dest) {
      toast.error("Selectați ambele gestiuni pentru transfer.");
      return;
    }
    setIsTransferring(true);
    try {
      await authFetch(`/comenzi/interna/${formOrder.bxid}/genereaza-transfer`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ gestiune_sursa_id: Number(transferState.sursa), gestiune_dest_id: Number(transferState.dest) })
      });
      toast.success("Bonul de transfer a fost generat cu succes!");
      setShowTransferModal(false);
      
      const updated = await authFetch(`/comenzi/interna/${formOrder.bxid}`);
      setSelectedInternalOrder(updated);
      setFormOrder(updated);
    } catch (e) {
      toast.error(e.message || "Eroare la generarea transferului.");
    } finally {
      setIsTransferring(false);
    }
  };


  const handleDeschideDeviz = async () => {
    if (!window.confirm("Sigur doriți să deschideți devizul? Se va șterge bonul de consum.")) return;
    setIsScading(true);
    try {
      const result = await authFetch(`/comenzi/interna/${formOrder.bxid}/deschide-deviz`, { method: "POST" });
      toast.success("Devizul a fost redeschis!");
      setSelectedInternalOrder(result);
      setFormOrder(result);
      fetchList();
    } catch (e) {
      toast.error(e.message || "Eroare la redeschiderea devizului.");
    } finally {
      setIsScading(false);
    }
  };

  const handleInchidere = async () => {
    if (!window.confirm("Sunteți sigur că doriți să închideți devizul și să generați bonul de consum automat?")) return;
    setIsScading(true);
    try {
      // Apelam endpoint-ul scade-stoc (backend-ul ia gestiunea automat din setarile firmei)
      const result = await authFetch(
        `/comenzi/interna/${formOrder.bxid}/scade-stoc?gestiune_id=1`, 
        { method: "POST" }
      );
      toast.success("Devizul a fost închis.");
      
      // Re-fetch the updated order from the server to get the new state
      const updatedOrder = await authFetch(`/comenzi/interna/${formOrder.bxid}`);
      setFormOrder(updatedOrder);
      fetchList(); // refresh the grid too
      
    } catch (e) {
      toast.error(e.message || "Eroare la închidere/scădere stoc.");
    } finally {
      setIsScading(false);
    }
  };

  const pageCount = Math.max(1, Math.ceil(totalCount / itemsPerPage));
  const from = totalCount ? currentPage * itemsPerPage + 1 : 0;
  const to = Math.min(totalCount, (currentPage + 1) * itemsPerPage);

  return (
    <Container fluid className="px-4 py-4">
      {/* Page Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
        <div>
          <h2 className="fw-bold text-dark mb-1">
            {appVariant === "SERVICE_AUTO"
              ? "Comenzi Interne (Auto)"
              : "Comenzi Interne"}
          </h2>
          <p className="text-muted mb-0">
            Vizualizare, urmărire și editare comenzi interne, adăugare manoperă
            și rețete materiale.
          </p>
        </div>
        {(appVariant === "SERVICE_AUTO" || appVariant === "SIMAUS") && (
          <Button
            variant="success"
            className="fw-bold px-3"
            onClick={handleAddInternalOrder}
          >
            + Adaugă Comandă Internă
          </Button>
        )}
      </div>

      {/* Filters Section */}
      <Card className="shadow-sm border-0 mb-4 bg-light">
        <Card.Body className="p-3">
          <Form onSubmit={handleSearchSubmit}>
            <Row className="g-3 align-items-end">
              <Col lg={6} md={8}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-muted small text-uppercase">
                    Caută
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Nr. comandă, descriere, client, cod piesă, șasiu, număr auto..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col lg={2} md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-muted small text-uppercase">
                    Rânduri
                  </Form.Label>
                  <Form.Select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(0);
                    }}
                  >
                    {[10, 20, 50, 100].map((n) => (
                      <option key={n} value={n}>
                        {n} pe pagină
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col lg={4} md={12} className="d-flex gap-2">
                <Button
                  type="submit"
                  variant="primary"
                  className="w-100 fw-semibold"
                >
                  Filtrează
                </Button>
                <Button
                  variant="outline-secondary"
                  onClick={handleClearFilters}
                  className="w-100 fw-semibold"
                >
                  Resetează
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {error && (
        <Alert variant="danger" className="shadow-sm">
          {error}
        </Alert>
      )}

      {/* Grid Table */}
      <Card className="shadow-sm border-0">
        <Card.Body className="p-0">
          <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-light border-bottom">
            <span className="text-muted small fw-semibold">
              {totalCount
                ? `Afișare înregistrări: ${from}-${to} din ${totalCount}`
                : "Nu s-au găsit înregistrări"}
            </span>
          </div>

          {loading ? (
            <div className="py-5 text-center">
              <Spinner animation="border" variant="primary" className="my-3" />
              <p className="text-muted mb-0">Se încarcă datele...</p>
            </div>
          ) : (
            <div className="table-responsive">
              <Table
                hover
                striped
                bordered
                className="align-middle mb-0 text-nowrap"
                size="sm"
              >
                <thead className="table-dark">
                  <tr>
                    <th className="text-center" style={{ width: "40px" }}>
                      No
                    </th>
                    <th style={{ width: "50px" }}>Id</th>
                    <th style={{ width: "80px" }}>Număr</th>
                    <th style={{ width: "90px" }}>Dată</th>
                    <th style={{ width: "90px" }}>Închis la</th>
                    <th style={{ width: "150px" }}>Client</th>
                    <th style={{ width: "120px" }}>Cod Piesă</th>
                    <th style={{ width: "180px" }}>Denumire Piesă</th>
                    <th className="text-center" style={{ width: "60px" }}>
                      Cantitate
                    </th>
                    <th className="text-end" style={{ width: "80px" }}>
                      Preț
                    </th>
                    <th className="text-end" style={{ width: "100px" }}>
                      Valoare
                    </th>
                    <th style={{ width: "120px" }}>Șasiu</th>
                    <th style={{ width: "100px" }}>Număr Auto</th>
                    <th style={{ width: "120px" }}>Facturare</th>
                      <th style={{ width: "100px" }}>Tip client</th>
                    <th>Descriere / Obs</th>
                    <th className="text-center" style={{ width: "80px" }}>
                      Detalii
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((it, idx) => {
                    const rowNumber = currentPage * itemsPerPage + idx + 1;
                    return (
                      <tr key={it.bxid}>
                        <td className="text-center fw-semibold text-muted bg-light">
                          {rowNumber}
                        </td>
                        <td className="fw-mono small">{it.bxid}</td>
                        <td className="fw-semibold">
                          {it.bxnumar_comanda || "-"}
                        </td>
                        <td>{formatDateRo(it.bxdata_comanda)}</td>
                        <td>{it.bxdatafin ? formatDateRo(it.bxdatafin) : "-"}</td>
                        <td
                          className="text-truncate"
                          style={{ maxWidth: "200px" }}
                          title={it.customer_name}
                        >
                          {it.customer_name || "-"}
                        </td>
                        <td className="fw-bold">{it.part_code || "-"}</td>
                        <td
                          className="text-truncate"
                          style={{ maxWidth: "220px" }}
                          title={it.part_name}
                        >
                          {it.part_name || "-"}
                        </td>
                        <td className="text-center fw-semibold">
                          {it.bxcantitate}
                        </td>
                        <td className="text-end fw-mono">
                          {Number(it.bxprice || 0).toFixed(2)}
                        </td>
                        <td className="text-end fw-mono fw-bold">
                          {Number(it.bxlvalue || 0).toFixed(2)}
                        </td>
                        <td className="text-muted">{it.bxsasiu || "-"}</td>
                        <td>{it.bxnumar || "-"}</td>
                        <td>
                          {it.factura_id ? (
                            <a href={`/iesire/${it.factura_id}`} target="_blank" rel="noreferrer">
                              {it.factura_no || "Factura"}
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>{it.tip_client_label || "-"}</td>
                        <td
                          className="text-truncate"
                          style={{ maxWidth: "200px" }}
                          title={it.bxdescr}
                        >
                          {it.bxdescr || "-"}
                        </td>
                        <td className="text-center">
                          <div className="d-flex gap-1 justify-content-center">
                            <Button
                              variant="primary"
                              size="sm"
                              className="py-0 px-2 fw-semibold"
                              onClick={() => handleViewInternalOrder(it.bxid)}
                            >
                              Edit
                            </Button>
                            <Button
                              variant="info"
                              size="sm"
                              className="py-0 px-2 text-white fw-semibold"
                              onClick={() => handlePrintDeviz(it.bxid)}
                            >
                              {appVariant === "SERVICE_AUTO" ? "Print comandă" : "Print deviz"}
                            </Button>
                            <Button
                              variant="success"
                              size="sm"
                              className="py-0 px-2 text-white fw-semibold"
                disabled={Number(it.tipcomanda_id) === 1}
                title={Number(it.tipcomanda_id) === 1 ? "Devizele interne nu se pot factura." : undefined}
                onClick={async () => {
                                if (Number(it.tipcomanda_id) === 1) {
                      toast.error("Devizele interne nu se pot factura.");
                      return;
                  }
                  if (!it.bxdatafin) {
                                    toast.error("Devizul este deschis. Închideți devizul înainte de facturare!");
                                    return;
                                }
                                if (it.factura_id) {
                                    toast.error("Devizul a fost deja facturat!");
                                    return;
                                }
                                try {
                                    const fullDeviz = await authFetch(`/comenzi/interna/${it.bxid}`);
                                    if (Number(fullDeviz.tipcomanda_id) === 1) {
                          toast.error("Devizele interne nu se pot factura.");
                          return;
                      }
                      if (fullDeviz.factura_id) {
                                        toast.error(`Devizul a fost deja facturat (Factura ${fullDeviz.factura_no || ""})!`);
                                        return;
                                    }
                                    const lines = [];
                                    
                                    let repPartId = null;
                                    let repPartLabel = "";
                                    try {
                                        const repRes = await authFetch("/bxpart?search=REPARATIE AUTO");
                                        if (repRes && repRes.items && repRes.items.length > 0) {
                                            const match = repRes.items.find(p => p.denumire?.toUpperCase() === "REPARATIE AUTO" || p.cod?.toUpperCase() === "REPARATIE AUTO");
                                            const p = match || repRes.items[0];
                                            repPartId = p.id;
                                            repPartLabel = p.denumire;
                                        }
                                    } catch (e) {
                                        console.error("Nu am gasit piesa REPARATIE AUTO", e);
                                    }
                                    
                                    if (fullDeviz.manopere && fullDeviz.manopere.length > 0) {
                                        
                                        fullDeviz.manopere.forEach(m => {
                                            const lQty = Number(m.bxqty_manopera) || 1;
                                            const lPrice = Number(m.bxpret_manopera) || 0;
                                            lines.push({
                                                descriere: "[M] " + (m.bxmanoperacod || "MAN") + " | " + (m.bxspecificatii || m.manopera_name || "Manopera"),
                                                qty: lQty,
                                                price: lPrice,
                                                vat_rate: 19,
                                                bxpart_id: repPartId,
                                                bxpart_label: repPartLabel
                                            });
                                        });
                                        
                                    }
                                    
                                    if (fullDeviz.reteta && fullDeviz.reteta.length > 0) {
                                        
                                        fullDeviz.reteta.forEach(r => {
                                            const lQty = Number(r.bxnorma) || 1;
                                            const lPrice = Number(r.pretvanzare) || 0;
                                            lines.push({
                                                descriere: "[P] " + (r.part_code || "PIESA") + " | " + (r.part_name || "Piesa de schimb"),
                                                qty: lQty,
                                                price: lPrice,
                                                vat_rate: 19,
                                                bxpart_id: repPartId,
                                                bxpart_label: repPartLabel
                                            });
                                        });
                                        
                                    }
                                    const obsArr1 = [];
                                    if (fullDeviz.bxnumar) obsArr1.push(`Auto: ${fullDeviz.bxnumar}`);
                                    if (fullDeviz.bxsasiu) obsArr1.push(`Serie sasiu: ${fullDeviz.bxsasiu}`);
                                    if (fullDeviz.bxkm) obsArr1.push(`Km: ${fullDeviz.bxkm}`);
                                    
                                    const facturaData = {
                                      observatii: obsArr1.join(" | "),
                                      contact_id: it.bxcustomer_id || it.contact_id,
                                      contact_label: it.customer_name || "",
                                      valoare: it.bxlvalue,
                                      numar_comanda: it.bxnumar_comanda || it.bxid,
                                      deviz_id: it.bxid,
                                      print_details: {transport: fullDeviz.service_details?.marca_model || '', registration: fullDeviz.bxnumar || fullDeviz.service_details?.numar_auto || ''},
                                      descriere: `Reparatie conform deviz`,
                                      lines: lines
                                    };
                                    openDevizInvoice(facturaData);
                                } catch (err) {
                                    console.error("Eroare la preluarea devizului", err);
                                }
                              }}
                            >
                              Facturare
                            </Button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                  {items.length === 0 && (
                    <tr>
                      <td
                        colSpan={17}
                        className="text-center text-muted py-5 fs-5 bg-light"
                      >
                        Nu s-au găsit comenzi interne. Modificați filtrele sau
                        verificați conexiunea.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>

        <Card.Footer className="bg-white border-top py-3">
          <ReactPaginate
            previousLabel={"← Înapoi"}
            nextLabel={"Înainte →"}
            pageCount={pageCount}
            forcePage={currentPage}
            onPageChange={(event) => setCurrentPage(event.selected)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            containerClassName={"pagination justify-content-center mb-0"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            renderOnZeroPageCount={null}
          />
        </Card.Footer>
      </Card>

      {/* Internal Order Details Modal */}
      <Modal
        show={showInternalOrderModal}
        onHide={() => {
          setShowInternalOrderModal(false);
          setSelectedInternalOrder(null);
          setFormOrder(null);
        }}
        backdrop="static"
        keyboard={false}
        size="xl"
        centered
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title className="fw-bold d-flex align-items-center">
            <span>
            {formOrder?.bxid
              ? `Editare Comandă Internă #${formOrder.bxnumar_comanda}`
              : "Adăugare Comandă Internă"}
            </span>
            {formOrder?.bxdatafin && (
               <span className="badge bg-danger ms-3 fs-6">
                 ÎNCHIS LA: {new Date(formOrder.bxdatafin).toLocaleDateString("ro-RO")}
               </span>
            )}
            {formOrder?.bxid && !formOrder?.bxdatafin && (
               <span className="badge bg-success ms-3 fs-6">
                 DESCHIS (ÎN LUCRU)
               </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {loadingInternalOrder ? (
            <div className="py-5 text-center">
              <Spinner animation="border" variant="primary" />
              <p className="text-muted mt-2">Se încarcă detaliile...</p>
            </div>
          ) : formOrder ? (
            <Tabs
              activeKey={modalTab}
              onSelect={(k) => setModalTab(k)}
              className="mb-4"
            >
              <Tab eventKey="general" title="General">
                {appVariant === "SERVICE_AUTO" && <p className="text-muted small">Comanda și devizul au același număr. Închiderea devizului închide automat comanda de reparație.</p>}
                <Row className="g-3">
                  {appVariant === "SERVICE_AUTO" && (<Col md={3}>
                    <Form.Group controlId="service-vin">
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Serie Șasiu
                      </Form.Label>
                      <Form.Control
                        type="text"
                    autoFocus={appVariant === "SERVICE_AUTO"}
                    autoComplete="off"
                        value={formOrder.bxsasiu || ""}
                        onChange={(e) =>
                          handleHeaderChange("bxsasiu", e.target.value)
                        }
                      />
                      {vinMessage && <Form.Text role="status">{vinMessage}</Form.Text>}
                    </Form.Group>
                  </Col>)}
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Număr Comandă
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formOrder.bxnumar_comanda || ""}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Data Comandă
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formatDateRo(formOrder.bxdata_comanda) || ""}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Dată Închidere
                      </Form.Label>
                      <DatePicker
                        disabled={appVariant === "SERVICE_AUTO"}
                        selected={formOrder.bxdatafin ? new Date(formOrder.bxdatafin) : null}
                        onChange={(date) => {
                          const val = date ? date.toISOString() : null;
                          handleHeaderChange("bxdatafin", val);
                        }}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="dd/MM/yyyy HH:mm"
                        className="form-control"
                        isClearable
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Client
                      </Form.Label>
                      {formOrder.bxid ? (
                        <Form.Control
                          type="text"
                          value={formOrder.customer_name || ""}
                          disabled
                        />
                      ) : (
                        <AsyncSelect
                          cacheOptions
                          defaultOptions
                          loadOptions={loadContacts}
                          placeholder="Caută client..."
                          value={
                            formOrder.bxcustomer_id
                              ? {
                                  value: formOrder.bxcustomer_id,
                                  label: formOrder.customer_name,
                                }
                              : null
                          }
                          onChange={(opt) => {
                            setFormOrder((prev) => ({
                              ...prev,
                              bxcustomer_id: opt ? opt.value : null,
                              customer_name: opt ? opt.label : "",
                            }));
                          }}
                        />
                      )}
                    </Form.Group>
                  </Col>

                  {appVariant !== "SERVICE_AUTO" && (
                    <>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label className="fw-semibold text-muted small text-uppercase">
                            Cod Piesă fabricat
                          </Form.Label>
                          <div className="d-flex gap-2">
                            <Form.Control
                              type="text"
                              value={formOrder.part_code || ""}
                              disabled
                            />
                            {!formOrder.bxid && (
                              <Button
                                variant="outline-secondary"
                                onClick={handleOpenPartPickerForMain}
                              >
                                Alege
                              </Button>
                            )}
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={8}>
                        <Form.Group>
                          <Form.Label className="fw-semibold text-muted small text-uppercase">
                            Denumire Piesă
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={formOrder.part_name || ""}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}

                  {!(appVariant === "SERVICE_AUTO") && (<Col md={3}>
                    <Form.Group controlId="service-vin">
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Serie Șasiu
                      </Form.Label>
                      <Form.Control
                        type="text"
                    autoFocus={appVariant === "SERVICE_AUTO"}
                    autoComplete="off"
                        value={formOrder.bxsasiu || ""}
                        onChange={(e) =>
                          handleHeaderChange("bxsasiu", e.target.value)
                        }
                      />
                      {vinMessage && <Form.Text role="status">{vinMessage}</Form.Text>}
                    </Form.Group>
                  </Col>)}
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Număr
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formOrder.bxnumar || ""}
                        onChange={(e) =>
                          handleHeaderChange("bxnumar", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Km
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formOrder.bxkm || ""}
                        onChange={(e) =>
                          handleHeaderChange("bxkm", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Dovadă
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formOrder.bxdovada || ""}
                        onChange={(e) =>
                          handleHeaderChange("bxdovada", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>

                  {appVariant !== "SERVICE_AUTO" && (
                    <>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="fw-semibold text-muted small text-uppercase">
                            Cantitate
                          </Form.Label>
                          <Form.Control
                            type="number"
                            step="any"
                            value={formOrder.bxcantitate ?? 0}
                            onChange={(e) =>
                              handleHeaderChange(
                                "bxcantitate",
                                Number(e.target.value),
                              )
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="fw-semibold text-muted small text-uppercase">
                            Preț Unitar
                          </Form.Label>
                          <Form.Control
                            type="number"
                            step="any"
                            value={formOrder.bxprice ?? 0}
                            onChange={(e) =>
                              handleHeaderChange("bxprice", Number(e.target.value))
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="fw-semibold text-muted small text-uppercase">
                            Valoare (Total)
                          </Form.Label>
                          <Form.Control
                            type="number"
                            value={Number(formOrder.bxlvalue ?? 0).toFixed(2)}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Tip Comandă
                      </Form.Label>
                      <Form.Select
                        value={formOrder.tipcomanda_id ?? 2}
                        onChange={(e) =>
                          handleHeaderChange(
                            "tipcomanda_id",
                            Number(e.target.value),
                          )
                        }
                      >
                        <option value={2}>Clienti</option>
                        <option value={1}>Intern</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  {appVariant !== "SERVICE_AUTO" && <Col xs={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-muted small text-uppercase">
                        Descriere / Observații
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        value={formOrder.bxdescr || ""}
                        onChange={(e) =>
                          handleHeaderChange("bxdescr", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>}
                </Row>
                  {appVariant === "SERVICE_AUTO" && <ServiceOrderFields value={formOrder.service_details || { solicitare: formOrder.bxdescr || "" }} onChange={details => handleHeaderChange("service_details", details)} />}
                  <HeaderCostCenter value={formOrder.centrucost_id} disabled={!!formOrder.bxdatafin} onChange={id => setFormOrder(prev => ({ ...prev, centrucost_id: id }))} />

              </Tab>

              {appVariant === "SERVICE_AUTO" && <Tab eventKey="anexe" title="Anexe / acord client" mountOnEnter unmountOnExit><ServiceAnnexes key={formOrder.bxid || "new"} orderId={formOrder.bxid} /></Tab>}

              <Tab eventKey="manopere" title="Manoperă (Labor)">
                <div className="table-responsive mt-3">
                  <Table bordered size="sm" className="align-middle">
                    <thead className="table-dark">
                      <tr>
                        <th style={{ width: "180px" }}>Data Manoperă</th>
                        <th style={{ width: "120px" }}>Cod Manoperă</th>
                        <th style={{ width: "90px" }}>Ore normate</th>
                        <th style={{ width: "110px" }}>Tarif lei/oră</th>
                        <th style={{ width: "110px" }}>Total</th>
                        <th>Specificații</th>
                        <th>Angajați / repartizare</th>
                        <th style={{ width: "80px" }} className="text-center">
                          Șterge
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(formOrder.manopere || []).map((m, idx) => (
                        <tr key={idx}>
                          <td>
                            <Form.Control
                              type="datetime-local"
                              size="sm"
                              value={formatDateTimeLocal(m.bxdata_manopera)}
                              onChange={(e) =>
                                handleUpdateManopera(
                                  idx,
                                  "bxdata_manopera",
                                  e.target.value
                                    ? new Date(e.target.value).toISOString()
                                    : "",
                                )
                              }
                            />
                          </td>
                          <td>
                            <div className="d-flex gap-1 align-items-center">
                              <Form.Control
                                type="text"
                                size="sm"
                                value={
                                  m.bxmanoperacod ?? m.bxmanoperacod_id ?? ""
                                }
                                readOnly
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setActiveManoperaLineIdx(idx);
                                  setManoperaPickerOpen(true);
                                }}
                              />
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                className="py-0 px-2"
                                onClick={() => {
                                  setActiveManoperaLineIdx(idx);
                                  setManoperaPickerOpen(true);
                                }}
                              >
                                🔍
                              </Button>
                            </div>
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              size="sm"
                              step="any"
                              value={m.bxqty_manopera === '' ? '' : Number(Number(m.bxqty_manopera ?? 0).toFixed(4))}
                              onChange={(e) =>
                                handleUpdateManopera(
                                  idx,
                                  "bxqty_manopera",
                                  Number(e.target.value),
                                )
                              }
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              size="sm"
                              step="any"
                              value={m.bxpret_manopera ?? 0}
                              onChange={(e) =>
                                handleUpdateManopera(
                                  idx,
                                  "bxpret_manopera",
                                  Number(e.target.value),
                                )
                              }
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              size="sm"
                              aria-label={`Total manoperă ${idx + 1}`}
                              min="0"
                              step="0.01"
                              value={m.bxtotal_manopera ?? 0}
                              disabled={!(Number(m.bxpret_manopera) > 0)}
                              title={Number(m.bxpret_manopera) > 0 ? "Introdu suma negociată; orele normate se recalculează, tariful rămâne neschimbat." : "Completează tariful pe oră pentru a putea negocia totalul."}
                              onChange={e => handleUpdateManopera(idx, "bxtotal_manopera", e.target.value === "" ? "" : Number(e.target.value))}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              size="sm"
                              value={m.bxspecificatii || ""}
                              onChange={(e) =>
                                handleUpdateManopera(
                                  idx,
                                  "bxspecificatii",
                                  e.target.value,
                                )
                              }
                              placeholder="Detalii..."
                            />
                          </td>
                          <td>
                            <LaborEmployees
                              value={m.detalii_angajati || []}
                              amount={
                                Number(m.bxqty_manopera || 0) *
                                Number(m.bxpret_manopera || 0)
                              }
                              onChange={(value) =>
                                handleUpdateManopera(
                                  idx,
                                  "detalii_angajati",
                                  value,
                                )
                              }
                            />
                          </td>
                          <td className="text-center">
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleRemoveManopera(idx)}
                            >
                              ✕
                            </Button>
                          </td>
                        </tr>
                      ))}
                      {(formOrder.manopere || []).length === 0 && (
                        <tr>
                          <td
                            colSpan={8}
                            className="text-center py-3 text-muted bg-light"
                          >
                            Nu există manopere adăugate pe această comandă.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <LaborEmployeeSummary rows={formOrder.manopere || []} />
                  <Button
                    variant="success"
                    size="sm"
                    onClick={handleAddManopera}
                    className="fw-semibold"
                  >
                    + Adaugă Manoperă
                  </Button>
                </div>
              </Tab>

              {appVariant === "SIMAUS" && (
                <Tab eventKey="reteta" title="Rețetă (Recipe / Materiale)">
                  <div className="table-responsive mt-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => handleAddRecipeLine(11)}
                        className="fw-semibold"
                      >
                        + Adaugă Rând Rețetă
                      </Button>
                      <div className="d-flex gap-2 align-items-center">
                        <Button
                          variant="primary"
                          size="sm"
                          className="fw-bold px-3"
                          disabled={
                            !(formOrder.reteta || []).some(
                              (r) => r.bxrectype === 11 && r.deluat > 0,
                            ) || isScading
                          }
                          onClick={handleScadeStoc}
                        >
                          {isScading ? (
                            <>
                              <Spinner
                                animation="border"
                                size="sm"
                                className="me-2"
                              />
                              Se scade...
                            </>
                          ) : (
                            "Scade din Stoc (FIFO)"
                          )}
                        </Button>
                      </div>
                    </div>

                    <Table bordered size="sm" className="align-middle">
                      <thead className="table-dark">
                        <tr>
                          <th style={{ width: "135px" }}>Dată Scădere</th>
                          <th>Produs / Material</th>
                          <th style={{ width: "120px" }}>U.M.</th>
                          <th style={{ width: "90px" }}>Norma</th>
                          <th style={{ width: "90px" }}>De luat</th>
                          <th style={{ width: "90px" }}>Luat</th>
                          <th style={{ width: "90px" }}>Rămas</th>
                          <th style={{ width: "110px" }}>Preț magazie</th>
                          <th style={{ width: "100px" }}>Adaos (%)</th>
                          <th style={{ width: "110px" }}>Preț Vânzare</th>
                          <th style={{ width: "110px" }}>Tip Rec</th>
                          <th style={{ width: "80px" }} className="text-center">
                            Șterge
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {(formOrder.reteta || []).map((r, idx) => {
                          if (r.bxrectype !== 11) return null;
                          return (
                            <tr key={idx}>
                              <td>
                                <Form.Control
                                  type="date"
                                  size="sm"
                                  value={r.data_scadere || ""}
                                  onChange={(e) =>
                                    handleUpdateRecipeLine(
                                      idx,
                                      "data_scadere",
                                      e.target.value,
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <div className="d-flex gap-2 align-items-center">
                                  <span className="fw-semibold text-dark">
                                    {r.part_code
                                      ? `${r.part_code} • ${r.part_name}`
                                      : "(niciun produs selectat)"}
                                  </span>
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="py-0 px-2 ms-auto"
                                    onClick={() =>
                                      handleOpenPartPickerForRecipe(idx)
                                    }
                                  >
                                    Caută
                                  </Button>
                                </div>
                              </td>
                              <td>
                                <Form.Select
                                  size="sm"
                                  value={r.bxum_id}
                                  onChange={(e) =>
                                    handleUpdateRecipeLine(
                                      idx,
                                      "bxum_id",
                                      Number(e.target.value),
                                    )
                                  }
                                >
                                  {ums.map((opt) => (
                                    <option key={opt.id} value={opt.id}>
                                      {opt.cod}
                                    </option>
                                  ))}
                                </Form.Select>
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  size="sm"
                                  step="any"
                                  value={r.bxnorma ?? 0}
                                  onChange={(e) =>
                                    handleUpdateRecipeLine(
                                      idx,
                                      "bxnorma",
                                      Number(e.target.value),
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  size="sm"
                                  step="any"
                                  value={r.deluat ?? 0}
                                  onChange={(e) =>
                                    handleUpdateRecipeLine(
                                      idx,
                                      "deluat",
                                      Number(e.target.value),
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  size="sm"
                                  value={r.luat ?? 0}
                                  disabled
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  size="sm"
                                  value={Number(r.bxrestqty ?? 0).toFixed(2)}
                                  disabled
                                />
                              </td>
                              <RecipePriceCells row={r} onChange={(field, value) => handleUpdateRecipeLine(idx, field, value)} />
                              <td>
                                <Form.Control
                                  type="number"
                                  size="sm"
                                  step="any"
                                  value={r.pretvanzare ?? 0}
                                  onChange={(e) =>
                                    handleUpdateRecipeLine(
                                      idx,
                                      "pretvanzare",
                                      Number(e.target.value),
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Form.Select
                                  size="sm"
                                  value={r.bxrectype ?? 1}
                                  onChange={(e) =>
                                    handleUpdateRecipeLine(
                                      idx,
                                      "bxrectype",
                                      Number(e.target.value),
                                    )
                                  }
                                >
                                  <option value={11}>11 (Rețetă)</option>
                                  <option value={1}>1 (Material)</option>
                                  <option value={2}>2 (Obiect)</option>
                                </Form.Select>
                              </td>
                              <td className="text-center">
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() => handleRemoveRecipeLine(idx)}
                                >
                                  ✕
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                        {!(formOrder.reteta || []).some(
                          (r) => r.bxrectype === 11,
                        ) && (
                          <tr>
                            <td
                              colSpan={12}
                              className="text-center py-5 text-muted bg-light"
                            >
                              Nu există materiale adăugate în rețetă.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Tab>
              )}

              <Tab
                eventKey="materiale_direct"
                title={
                  appVariant === "SERVICE_AUTO"
                    ? "Piese / Materiale"
                    : "Piese / Materiale (Service)"
                }
              >
                <div className="table-responsive mt-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    
                    {!formOrder?.bxdatafin && (<Button
                      variant="success"
                      size="sm"
                      onClick={() => handleAddRecipeLine(1)}
                      className="fw-semibold"
                    >
                      + Adaugă Piese / Materiale
                    </Button>)}
                  </div>

                  <Table bordered size="sm" className="align-middle">
                    <thead className="table-dark">
                      <tr>
                        <th style={{ width: "135px" }}>Dată Scădere</th>
                        <th>Produs / Material</th>
                        <th style={{ width: "120px" }}>U.M.</th>
                        <th style={{ width: "120px" }}>Cantitate</th>
                        <th style={{ width: "110px" }}>Preț magazie</th>
                          <th style={{ width: "100px" }}>Adaos (%)</th>
                          <th style={{ width: "130px" }}>Preț Vânzare</th>
                        {appVariant !== "SERVICE_AUTO" && <th style={{ width: "130px" }}>Tip Rec</th>}
                        <th style={{ width: "80px" }} className="text-center">
                          Șterge
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(formOrder.reteta || []).map((r, idx) => {
                        if (r.bxrectype === 11) return null;
                        return (
                          <tr key={idx}>
                            <td>
                              <DatePicker
                                selected={r.data_scadere ? new Date(r.data_scadere) : null}
                                onChange={(date) => {
                                  const val = date ? date.toLocaleDateString('en-CA') : "";
                                  handleUpdateRecipeLine(idx, "data_scadere", val);
                                }}
                                dateFormat="dd/MM/yyyy"
                                className="form-control form-control-sm"
                                isClearable
                              />
                            </td>
                            <td>
                              <div className="d-flex gap-2 align-items-center">
                                <span className="fw-semibold text-dark">
                                  {r.part_code
                                    ? `${r.part_code} • ${r.part_name}`
                                    : "(niciun produs selectat)"}
                                </span>
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  className="py-0 px-2 ms-auto"
                                  onClick={() =>
                                    handleOpenPartPickerForRecipe(idx)
                                  }
                                >
                                  Caută
                                </Button>
                              </div>
                            </td>
                            <td>
                              <Form.Select
                                size="sm"
                                value={r.bxum_id}
                                onChange={(e) =>
                                  handleUpdateRecipeLine(
                                    idx,
                                    "bxum_id",
                                    Number(e.target.value),
                                  )
                                }
                              >
                                {ums.map((opt) => (
                                  <option key={opt.id} value={opt.id}>
                                    {opt.cod}
                                  </option>
                                ))}
                              </Form.Select>
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                size="sm"
                                step="any"
                                value={r.bxnorma ?? 0}
                                onChange={(e) =>
                                  handleUpdateRecipeLine(
                                    idx,
                                    "bxnorma",
                                    Number(e.target.value),
                                  )
                                }
                              />
                            </td>
                            <RecipePriceCells row={r} onChange={(field, value) => handleUpdateRecipeLine(idx, field, value)} />
                            <td>
                              <Form.Control
                                type="number"
                                size="sm"
                                step="any"
                                value={r.pretvanzare ?? 0}
                                onChange={(e) =>
                                  handleUpdateRecipeLine(
                                    idx,
                                    "pretvanzare",
                                    Number(e.target.value),
                                  )
                                }
                              />
                            </td>
                            {appVariant !== "SERVICE_AUTO" && <td>
                              <Form.Select
                                size="sm"
                                value={r.bxrectype ?? 1}
                                onChange={(e) =>
                                  handleUpdateRecipeLine(
                                    idx,
                                    "bxrectype",
                                    Number(e.target.value),
                                  )
                                }
                              >
                                <option value={1}>1 (Material)</option>
                                <option value={2}>2 (Obiect)</option>
                              </Form.Select>
                            </td>}
                            <td className="text-center">
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleRemoveRecipeLine(idx)}
                              >
                                ✕
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                      {!(formOrder.reteta || []).some(
                        (r) => r.bxrectype !== 11,
                      ) && (
                        <tr>
                          <td
                            colSpan={appVariant === "SERVICE_AUTO" ? 8 : 9}
                            className="text-center py-5 text-muted bg-light"
                          >
                            Nu există piese sau materiale adăugate direct.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Tab>
            </Tabs>
          ) : (
            <Alert variant="warning">Nu s-au putut încărca datele...</Alert>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light">
          {formOrder && formOrder.bxid && (
            <>
              <Button
                variant="info"
                className="text-white fw-bold me-auto"
                onClick={() => handlePrintDeviz(formOrder.bxid)}
              >
                {appVariant === "SERVICE_AUTO" ? "Print comandă" : "Print deviz"}
              </Button>
              {appVariant === "SERVICE_AUTO" && <Button variant="outline-primary" onClick={() => setModalTab("anexe")}>Print anexă</Button>}
              {appVariant === "SERVICE_AUTO" && <small className="text-muted">Tipărirea folosește datele salvate.</small>}
              <Button
                variant="success"
                className="text-white fw-bold me-2"
                disabled={Number(formOrder.tipcomanda_id) === 1}
                title={Number(formOrder.tipcomanda_id) === 1 ? "Devizele interne nu se pot factura." : undefined}
                onClick={async () => {
                  if (Number(formOrder.tipcomanda_id) === 1) {
                      toast.error("Devizele interne nu se pot factura.");
                      return;
                  }
                  if (!formOrder.bxdatafin) {
                      toast.error("Devizul este deschis. Închideți devizul înainte de facturare!");
                      return;
                  }
                  if (formOrder.factura_id) {
                      toast.error("Devizul a fost deja facturat!");
                      return;
                  }
                  
                  try {
                      const checkDeviz = await authFetch(`/comenzi/interna/${formOrder.bxid}`);
                      if (Number(checkDeviz.tipcomanda_id) === 1) {
                          toast.error("Devizele interne nu se pot factura.");
                          return;
                      }
                      if (checkDeviz.factura_id) {
                          toast.error(`Devizul a fost deja facturat (Factura ${checkDeviz.factura_no || ""})! Vă rugăm să reîncărcați pagina.`);
                          return;
                      }
                  } catch(e) {
                      toast.error(e.message || "Nu s-a putut verifica devizul pentru facturare.");
                      return;
                  }
                  
                  let repPartId = null;
                  let repPartLabel = "";
                  try {
                      const repRes = await authFetch("/bxpart?search=REPARATIE AUTO");
                      if (repRes && repRes.items && repRes.items.length > 0) {
                          const match = repRes.items.find(p => p.denumire?.toUpperCase() === "REPARATIE AUTO" || p.cod?.toUpperCase() === "REPARATIE AUTO");
                          const p = match || repRes.items[0];
                          repPartId = p.id;
                          repPartLabel = p.denumire;
                      }
                  } catch (e) {
                      console.error("Nu am gasit piesa REPARATIE AUTO", e);
                  }
                  
                  const lines = [];
                  
                  if (formOrder.manopere && formOrder.manopere.length > 0) {
                      
                      formOrder.manopere.forEach(m => {
                          const lQty = Number(m.bxqty_manopera) || 1;
                          const lPrice = Number(m.bxpret_manopera) || 0;
                          lines.push({
                              descriere: "[M] " + (m.bxmanoperacod || "MAN") + " | " + (m.bxspecificatii || m.manopera_name || "Manopera"),
                              qty: lQty,
                              price: lPrice,
                              vat_rate: 19,
                              bxpart_id: repPartId,
                              bxpart_label: repPartLabel
                          });
                      });
                      
                  }
                  
                  if (formOrder.reteta && formOrder.reteta.length > 0) {
                      
                      formOrder.reteta.forEach(r => {
                          const lQty = Number(r.bxnorma) || 1;
                          const lPrice = Number(r.pretvanzare) || 0;
                          lines.push({
                              descriere: "[P] " + (r.part_code || "PIESA") + " | " + (r.part_name || "Piesa de schimb"),
                              qty: lQty,
                              price: lPrice,
                              vat_rate: 19,
                              bxpart_id: repPartId,
                              bxpart_label: repPartLabel
                          });
                      });
                      
                  }
                  const obsArr2 = [];
                  if (formOrder.bxnumar) obsArr2.push(`Auto: ${formOrder.bxnumar}`);
                  if (formOrder.bxsasiu) obsArr2.push(`Serie sasiu: ${formOrder.bxsasiu}`);
                  if (formOrder.bxkm) obsArr2.push(`Km: ${formOrder.bxkm}`);
                  
                  const facturaData = {
                    observatii: obsArr2.join(" | "),
                    contact_id: formOrder.bxcustomer_id || formOrder.contact_id,
                    contact_label: formOrder.customer_name || "",
                    valoare: formOrder.bxlvalue,
                    numar_comanda: formOrder.bxnumar_comanda || formOrder.bxid,
                    deviz_id: formOrder.bxid,
                    print_details: {transport: formOrder.service_details?.marca_model || '', registration: formOrder.bxnumar || formOrder.service_details?.numar_auto || ''},
                    descriere: `Reparatie conform deviz`,
                    lines: lines
                  };
                  openDevizInvoice(facturaData);
                }}
              >
                Facturare
              </Button>
              <Button
                variant="danger"
                className="text-white fw-bold me-2"
                onClick={handleInchidere}
                disabled={isScading || !!formOrder?.bxdatafin}
              >
                {isScading ? "Se închide..." : "Închide deviz"}
              </Button>
              <Button
                variant="warning"
                className="text-dark fw-bold me-2"
                onClick={handleDeschideDeviz}
                disabled={isScading || !formOrder?.bxdatafin}
              >
                Deschide deviz
              </Button>
            </>
          )}
          <Button
            variant="secondary"
            onClick={() => setShowInternalOrderModal(false)}
            disabled={savingInternalOrder}
          >
            Închide
          </Button>
          {formOrder && (
            <Button
              variant="primary"
              onClick={handleSaveInternalOrder}
              disabled={savingInternalOrder || !!(formOrder && formOrder.bxdatafin)}
            >
              {savingInternalOrder ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Se salvează...
                </>
              ) : (
                "Salvează modificări"
              )}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Part Picker Modal */}
      <PartPickerModal
        show={partPickerOpen}
        onHide={() => {
          setPartPickerOpen(false);
          setPickingMainPart(false);
        }}
        onPick={handlePickPart}
      />

      {/* Stoc Curent Picker Modal */}
      <StocCurentPickerModal
        show={stocPickerOpen}
        onHide={() => {
          setStocPickerOpen(false);
          setActiveRecipeLineIdx(null);
        }}
        onPick={handlePickPartForRecipe}
        gestiuneId={1}
      />

      {/* Manopera Picker Modal */}
      <ManoperaPickerModal
        show={manoperaPickerOpen}
        onHide={() => {
          setManoperaPickerOpen(false);
          setActiveManoperaLineIdx(null);
        }}
        onPick={handlePickManopera}
      />

      {/* Modal Transfer */}
      <Modal show={showTransferModal} onHide={() => setShowTransferModal(false)} centered>
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>Transfer Piese (Depozit → Service)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Gestiune Sursă (Ex: Depozit)</Form.Label>
            <Form.Select
              value={transferState.sursa}
              onChange={(e) => setTransferState(p => ({ ...p, sursa: e.target.value }))}
            >
              <option value="">Alege gestiune...</option>
              {gestiuni.map(g => (
                <option key={g.id} value={g.id}>{g.cod} - {g.denumire}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>Gestiune Destinație (Service)</Form.Label>
            <Form.Select
              value={transferState.dest}
              onChange={(e) => setTransferState(p => ({ ...p, dest: e.target.value }))}
            >
              <option value="">Alege gestiune...</option>
              {gestiuni.map(g => (
                <option key={g.id} value={g.id}>{g.cod} - {g.denumire}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <div className="mt-3 text-muted small">
            Vor fi transferate doar piesele din rețeta devizului care au "Norma" &gt; 0. Se va folosi metoda FIFO.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTransferModal(false)}>Anulează</Button>
          <Button variant="success" onClick={handleTransfer} disabled={isTransferring}>
            {isTransferring ? "Se transferă..." : "Confirmă Transfer"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Inchidere */}
      <Modal show={showInchidereModal} onHide={() => setShowInchidereModal(false)} centered>
        <Modal.Header closeButton className="bg-danger text-white">
          <Modal.Title>Închidere Deviz & Scădere Stoc</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Închiderea devizului închide și comanda. Piesele vor fi consumate din gestiunea selectată și trecute pe cheltuială.
            Totodată, data închiderii va fi completată cu data curentă.
          </p>
          <Form.Group>
            <Form.Label>Selectează Gestiunea (Service) din care se consumă:</Form.Label>
            <Form.Select
              value={inchidereGestiune}
              onChange={(e) => setInchidereGestiune(Number(e.target.value))}
            >
              <option value="">Alege gestiune...</option>
              {gestiuni.map(g => (
                <option key={g.id} value={g.id}>{g.cod} - {g.denumire}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowInchidereModal(false)}>Anulează</Button>
          <Button variant="danger" onClick={handleInchidere} disabled={isScading}>
            {isScading ? "Se închide..." : "Închide deviz"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
